import { Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import CnpjFormField from '../CnpjFormField';
import CpfFormField from '../CpfFormField';
import FloatingFormItem from '../FloatingFormItem';

interface CpfCnpjFieldProps {
  cpfCnpj: string;
  fieldName?: NamePath;
  disabled?: boolean;
  label?: string;
}

const CpfCnpjField: React.FC<CpfCnpjFieldProps> = ({
  cpfCnpj,
  fieldName,
  disabled,
  label,
}) => {
  if (cpfCnpj?.length === 11) {
    return <CpfFormField disabled={disabled} fieldName={fieldName} />;
  }
  if (cpfCnpj?.length === 14) {
    return <CnpjFormField disabled={disabled} fieldName={fieldName} />;
  }

  return (
    <FloatingFormItem label={label ? label : 'CPF/CNPJ'} name={fieldName}>
      <Input disabled={disabled} />
    </FloatingFormItem>
  );
};

export default CpfCnpjField;
